import { IAddtionalRequest } from "../../Interfaces/IAddtionalRequest"
import { ICartItem } from "../../Interfaces/ICardItem"
import { IProductRequest } from "../../Interfaces/IProductRequest"
import { ISelectedSelectionRequest } from "../../Interfaces/ISelectionRequest"

export const buildAddOnsSignature = (selectedAddOns: IAddtionalRequest[]) =>
  selectedAddOns
    .slice()
    .sort((a, b) => a.id - b.id)
    .map((a) => `${a.id}:${a.quantity}`)
    .join("|")

export const buildCartItemUniqueId = (
  productId: string,
  selectedAddOns: IAddtionalRequest[],
  selectedSelections: ISelectedSelectionRequest[],
  notes: string,
  isReservation: boolean,
  reservationDate: string,
  reservationTime: string,
) =>
  [
    productId,
    buildAddOnsSignature(selectedAddOns),
    selectedSelectionsSignature(selectedSelections),
    notes.trim(),
    isReservation ? "reservation" : "immediate",
    reservationDate.trim(),
    reservationTime.trim(),
  ].join("::")

export const selectedSelectionsSignature = (selectedSelections: ISelectedSelectionRequest[]) =>
  selectedSelections
    .slice()
    .sort((a, b) => a.selectionId - b.selectionId || a.optionId - b.optionId)
    .map((e) => `${e.selectionId}:${e.optionId}:${e.value}`)
    .join("|")

interface UpsertCartItemParams {
  currentCart: ICartItem[]
  product: IProductRequest
  selectedAddOns: IAddtionalRequest[]
  selectedSelections: ISelectedSelectionRequest[]
  quantity: number
  notes: string
  isReservation?: boolean
  reservationDate?: string
  reservationTime?: string
  replaceUniqueId?: string
}

export const upsertCartItem = ({
  currentCart,
  product,
  selectedAddOns,
  selectedSelections,
  quantity,
  notes,
  isReservation = false,
  reservationDate = "",
  reservationTime = "",
  replaceUniqueId,
}: UpsertCartItemParams): ICartItem[] => {
  const normalizedNotes = notes.trim()

  const nextItem: ICartItem = {
    ...product,
    quantity,
    selectedAddOns,
    selectedSelections,
    notes: normalizedNotes,
    isReservation,
    reservationDate: isReservation ? reservationDate : "",
    reservationTime: isReservation ? reservationTime : "",
    uniqueId: buildCartItemUniqueId(
      product.id,
      selectedAddOns,
      selectedSelections,
      normalizedNotes,
      isReservation,
      reservationDate,
      reservationTime,
    ),
  }

  const cartWithoutReplacedItem = replaceUniqueId
    ? currentCart.filter((item) => item.uniqueId !== replaceUniqueId)
    : currentCart

  const existingIndex = cartWithoutReplacedItem.findIndex((item) => item.uniqueId === nextItem.uniqueId)

  if (existingIndex >= 0) {
    return cartWithoutReplacedItem.map((item, index) =>
      index === existingIndex
        ? {
            ...item,
            ...nextItem,
            quantity: item.quantity + nextItem.quantity,
          }
        : item,
    )
  }

  return [...cartWithoutReplacedItem, nextItem]
}
